import { SAGA_ACTIONS } from '_config'
import { GetCmsContent } from '_common/interfaces/ApiReqRes'
import { useApiCall } from '../common/appApiCallHook'



export function useCmsApi() {

    const callApi = useApiCall()

    const getCmsContent = (data: GetCmsContent, onSuccess: (message: string, resp: any) => void, onError: (message: string, resp: any) => void) => {
        callApi(SAGA_ACTIONS.CMS.GET_CMS, data, onSuccess, onError);
    }

    return {
        callGetCmsContent: getCmsContent,
    }
}